export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// /Users/chrisessig/Documents/tribune/github/redistricting-CD27/node_modules/d3-scale/src/number.js
// module id = null
// module chunks = 